export default "__VITE_ASSET__BR$of2UI__"